module.exports = __webpack_public_path__ + "img/_2.4ea22cf8.png";